/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    arrayOf, shape, bool, number,
} from 'prop-types';
import { makeStyles } from '@material-ui/core';
import SkeletonStyles from '../../../../GraphqlSkeletonComponents/SkeletonStyles';

const useStyles = makeStyles((theme) => ({
    ...SkeletonStyles,
    crossedOutRetailPrice: {
        textDecoration: 'line-through',
        color: '#000000',
        fontWeight: 700,
    },
    priceContainer: {
        display: 'flex',
        flexDirection: 'column',
        fontSize: '16px',
        [theme.breakpoints.down('601')]: {
            fontSize: '14px',
        },
    },
    salePrice: {
        color: '#d1040c',
        [theme.breakpoints.up('800')]: {
            fontSize: '16px',
        },
    },
    productName: {
        fontWeight: '400',
    },
    wrapedPrice: {
        display: 'inline-block',
    },
}));

const getPrices = (skuPriceRange, type) => {
    if (!skuPriceRange) return {};
    const priceData = skuPriceRange[type];

    return {
        startingPrice: Number(priceData?.[0]?.value).toFixed(2),
        endingPrice: Number(priceData?.[priceData.length - 1]?.value).toFixed(2),
    };
};

const ProductPrice = ({
    skuPriceRange,
    isMobile,
    isRange,
}) => {
    const classes = useStyles({ isMobile });

    const {
        startingPrice: saleStarting = '',
        endingPrice: saleEnding = '',
    } = (getPrices(skuPriceRange, 'sale'));

    const {
        startingPrice: retailStarting = '',
        endingPrice: retailEnding = '',
    } = (getPrices(skuPriceRange, 'retail'));

    const isSale = saleStarting.toString() !== retailStarting.toString()
                    || saleEnding.toString() !== retailEnding.toString();

    let salePriceText = '';
    let retailPriceText = '';

    const filterOptionsDisplay = (filters = {}, start, end) => {
        const startPrice = start && parseFloat(start).toFixed(2);
        const endPrice = end && parseFloat(end).toFixed(2);
        if (startPrice || endPrice) {
            if (filters?.highToLowBtn) {
            // show ending/highest price
                return `$${endPrice}`;
            }
            // show starting/lowest price
            return `$${startPrice}`;
        }
        return '';
    };
    if (skuPriceRange) {
        retailPriceText = retailStarting !== retailEnding ? `$${retailStarting} - $${retailEnding}` : filterOptionsDisplay(retailStarting, retailEnding);
        if (isSale) {
            salePriceText = saleStarting !== saleEnding ? `$${saleStarting} - $${saleEnding}` : filterOptionsDisplay(saleStarting, saleEnding);

            return (
                <span className={`${isRange ? classes.priceContainer : ''}`} data-testid="sale-price">
                    <span className={`${classes.salePrice} ${classes.wrapedPrice} sale-price`}>
                        Now {salePriceText}
                    </span>
                    {' '}
                    <span className={`${classes.crossedOutRetailPrice} ${classes.wrapedPrice} crossed-price`}>
                        {retailPriceText}
                    </span>
                </span>
            );
        }
        return (
            <span data-testid="retail-price-range">
                <span className={`${isMobile ? classes.mobileCenteredPrice : ''}`}>
                    {retailPriceText}
                </span>
            </span>
        );
    }

    return null;
};

ProductPrice.propTypes = {
    skuPriceRange: shape({
        retail: arrayOf(shape({
            value: number,
        })),
        sale: arrayOf(shape({
            value: number,
        })),
    }),
    isMobile: bool,
    isRange: bool,
};

ProductPrice.defaultProps = {
    skuPriceRange: {},
    isMobile: false,
    isRange: false,
};

export default ProductPrice;
